// BL-983: zip codes are validated in-app against these rules instead of the
// Google Geocoding API. Hawaii and Alaska (and the 999 range) are outside the
// in-home setup service area, so they are a valid format but still rejected.
// No US ZIP starts with 000–004 (the lowest is 00501), so those fail the format
// check: without Google, this is what keeps 00000 from passing.
export const US_ZIP_REGEX = /^(?!00[0-4])\d{5}(-\d{4})?$/;
export const BLOCKED_ZIP_PREFIXES = ['967', '968', '995', '996', '997', '998', '999'];

export const ZIPCODE_REASONS = {
  OK: 'OK',
  INVALID_FORMAT: 'INVALID_FORMAT',
  BLOCKED_REGION: 'BLOCKED_REGION',
};

export function validateZipcode(zipcode) {
  const cleaned = (zipcode || '').toString().replace(/\s+/g, '');

  if (!US_ZIP_REGEX.test(cleaned)) {
    return { valid: false, reason: ZIPCODE_REASONS.INVALID_FORMAT };
  }

  if (BLOCKED_ZIP_PREFIXES.includes(cleaned.substring(0, 3))) {
    return { valid: false, reason: ZIPCODE_REASONS.BLOCKED_REGION };
  }

  return { valid: true, reason: ZIPCODE_REASONS.OK };
}
